<template>
    <div class="lifes">
        <h2>Vidas</h2>
        <img  src="../images/pokeball.png" :class=" lifes >= 1 ? '' : 'hideLifeBall'"/>
        <img  src="../images/pokeball.png" :class=" lifes >= 2 ? '' : 'hideLifeBall'"/>
        <img  src="../images/pokeball.png" :class=" lifes == 3 ? '' : 'hideLifeBall'"/>
    </div>
</template>

<script>
export default {
   props: {
        lifes: {
            type: Number,
            required: true,
            default: 3
        }
   }
}
</script>

<style scoped>

.lifes{
    background-color: rgb(167, 167, 167);
    padding: 10px;
    border-radius: 10%;
}

img{
    width: 40px;
    height: 40px;
}
.hideLifeBall {
    visibility: hidden;
}

    
</style>